import { cssTransition, Slide } from 'react-toastify';

let fade;

// react-toastify removes a toast when its exit animation ends, so the toast
// must keep an animation under reduced motion: a plain fade, which moves
// nothing, and no collapse of the toasts left in place.
const getToastTransition = () => {
  if (!window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) {
    return Slide;
  }
  fade =
    fade ||
    cssTransition({
      enter: 'animate-contentIn',
      exit: 'animate-toastFadeOut',
      collapse: false,
    });
  return fade;
};

export default getToastTransition;
